<div ngbAccordion class="accordion filters-accordion">
  <div
    ngbAccordionItem
    *ngFor="let filter_item of filters"
    class="{{ accordion_item_classes }}"
    [collapsed]="false"
  >
    <h2 ngbAccordionHeader class="accordion-header border-bottom-0">
      <button
        ngbAccordionButton
        class="border-0 bg-transparent fw-medium px-0 pt-0 pb-2 filters-accordion__item--title"
      >
        {{ filter_item.config.filter_display_name }}
      </button>
    </h2>

    <div ngbAccordionCollapse>
      <div
        ngbAccordionBody
        class="px-0 py-0 mb-3"
        [ngClass]="{
          'text-break':
            filter_item.config.filter_display_name === translation_svc.translate('Business Purpose')
        }"
      >
        <ng-template>
          <div *ngFor="let option of filter_item.items; let i = index" class="form-check">
            <input
              type="checkbox"
              id="filter-{{ filter_item.config.filter_display_name }}-{{ i }}"
              class="form-check-input"
              [checked]="option.active"
              (change)="
                handleFilterSelection(filter_item.config.filter_config_id, option.item, $event)
              "
            />
            <label
              class="fw-normal"
              for="filter-{{ filter_item.config.filter_display_name }}-{{ i }}"
            >
              {{ option.item }}
            </label>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
